var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Pagination, Box } from '@mui/material';
import React from 'react';
export var DefaultPagination = function (_a) {
    var currentPage = _a.currentPage, totalPages = _a.totalPages, onPageChange = _a.onPageChange;
    return (_jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'center' } }, { children: _jsx(Pagination, { onChange: function (e, page) { return onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(page); }, count: totalPages, page: currentPage, color: "primary" }) })));
};
